import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';

const FormationPage = () => {
  // Fonction pour obtenir le chemin des images
  const getImagePath = (fileName) => {
    if (!fileName || fileName.trim() === '') return null;
    
    const cleanName = fileName.trim();
    const extensions = ['.jpg', '.jpeg', '.png', '.webp', '.JPG', '.JPEG', '.PNG'];
    const hasExtension = extensions.some(ext => cleanName.endsWith(ext));
    
    if (hasExtension) {
      return `/assets/formation/${cleanName}`;
    } else {
      return `/assets/formation/${cleanName}.png`;
    }
  };

  return (
    <div style={styles.container}>
      <NavigationBar />
      
      <main style={styles.main}>
        {/* En-tête avec titre principal */}
        <header style={styles.header}>
          <h4 style={styles.mainTitle}>
            Formation des agents enquêteurs
          </h4>
          <h6 style={styles.subTitle}>
            Pour l'Enquête Intégrée sur les Conditions de Vie des Ménages 2025-2026
          </h6>
          <div style={styles.dateBox}>
            <div style={styles.dateIcon}>📅</div>
            <div style={styles.dateText}>
              <div style={styles.dateLabel}>Date du commencement de la formation</div>
              <div style={styles.dateValue}>04 Février 2026</div>
            </div>
          </div>
        </header>

        {/* Section introduction concise */}
        <section style={styles.introSection}>
          <div style={styles.introContent}>
            <h3 style={styles.introTitle}>Contexte</h3>
            <p style={styles.introText}>
              Le Directeur Général de l'Institut National de la Statistique du Burundi (INSBU) a officiellement procédé au lancement de l’Enquête Intégrée sur les Conditions de Vie des Ménages au Burundi (EICVMB 2025-2026). Cette cérémonie a été suivie par l’organisation d’une session de formation à l’intention des agents enquêteurs chargés de la collecte des données. La mise en œuvre de cette enquête permettra d’actualiser le profil de la pauvreté au Burundi et de produire des indicateurs fiables destinés à l’évaluation des programmes et politiques de développement national.
            </p>
          </div>
          <div style={styles.introIcon}>📊</div>
        </section>

        {/* Section galerie photos */}
        <section style={styles.gallerySection}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionNumber}>01</div>
            <h5 style={styles.sectionTitle}>Galerie de la formation</h5>
          </div>
          
          {/* Première rangée - Grande photo */}
          <div style={styles.photoGrid}>
            <div style={styles.largePhotoContainer}>
              <img 
                src={getImagePath("dg_consultante.jpeg")} 
                alt="Ouverture officielle de la formation" 
                style={styles.largePhoto}
              />
              <div style={styles.photoOverlay}>
                <span style={styles.photoTag}>Cérémonie d'ouverture</span>
                <p style={styles.photoDescription}>
                  Le Directeur Général de l'INSBU et la consultante de l'enquête EICVMB 2025-2026
                </p>
              </div>
            </div>
          </div>
          
          {/* Deuxième rangée - Trois photos */}
          <div style={styles.photoGrid}>
            <div style={styles.photoCard}>
              <img 
                src={getImagePath("formateur.jpeg")} 
                alt="Session de formation en cours" 
                style={styles.photo}
              />
              <div style={styles.photoInfo}>
                <h4 style={styles.photoTitle}>Formation technique</h4>
                <p style={styles.photoCaption}>
                  Le Directeur du département DCDC, formateur, explique les modules du questionnaire aux agents de l'enquête
                </p>
              </div>
            </div>
            
            <div style={styles.photoCard}>
              <img 
                src={getImagePath("participants1.jpeg")} 
                alt="Participants attentifs" 
                style={styles.photo}
              />
              <div style={styles.photoInfo}>
                <h4 style={styles.photoTitle}>Séance théorique</h4>
                <p style={styles.photoCaption}>
                  Les agents enquêteurs suivent attentivement les explications
                </p>
              </div>
            </div>
            
          </div>
        </section>

        {/* Section objectifs de la formation */}
        <section style={styles.objectivesSection}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionNumber}>02</div>
            <h5 style={styles.sectionTitle}>Objectifs de la formation</h5>
          </div>
          
          <div style={styles.objectivesGrid}>
            <div style={styles.objectiveCard}>
              <div style={styles.objectiveIcon}>✅</div>
              <h3 style={styles.objectiveTitle}>Maîtriser le questionnaire</h3>
              <p style={styles.objectiveText}>
                Comprendre toutes les sections du questionnaire EICVMB 2025-2026
              </p>
            </div>
            
            <div style={styles.objectiveCard}>
              <div style={styles.objectiveIcon}>📱</div>
              <h3 style={styles.objectiveTitle}>Utiliser les outils numériques</h3>
              <p style={styles.objectiveText}>
                Apprendre à utiliser les tablettes et applications de collecte
              </p>
            </div>
            
            <div style={styles.objectiveCard}>
              <div style={styles.objectiveIcon}>🎯</div>
              <h3 style={styles.objectiveTitle}>Assurer la qualité</h3>
              <p style={styles.objectiveText}>
                Garantir des données fiables grâce aux protocoles standardisés
              </p>
            </div>
            
            <div style={styles.objectiveCard}>
              <div style={styles.objectiveIcon}>🤝</div>
              <h3 style={styles.objectiveTitle}>Approcher les ménages</h3>
              <p style={styles.objectiveText}>
                Développer des techniques efficaces d'interview et de communication
              </p>
            </div>
          </div>
        </section>

        {/* Section calendrier de collecte */}
        <section style={styles.timelineSection}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionNumber}>03</div>
            <h2 style={styles.sectionTitle}>Calendrier de la collecte</h2>
          </div>
          
          <div style={styles.timeline}>
            <div style={styles.timelineItem}>
              <div style={styles.timelineDot}></div>
              <div style={styles.timelineContent}>
                <div style={styles.timelineDate}>04 Février 2026</div>
                <h3 style={styles.timelineTitle}>Début de la formation</h3>
                <p style={styles.timelineText}>
                  Formation intensive des agents enquêteurs à Bujumbura
                </p>
              </div>
            </div>
            
            <div style={styles.timelineItem}>
              <div style={styles.timelineDot}></div>
              <div style={styles.timelineContent}>
                <div style={styles.timelineDate}>Mars 2026 - Février 2027</div>
                <h3 style={styles.timelineTitle}>Déploiement des équipes et la Collecte nationale</h3>
                <p style={styles.timelineText}>
                  Les agents formés sont déployés dans toutes les provinces du Burundi
                </p>
                 <div style={styles.highlightBox}>
                  <div style={styles.highlightIcon}>📍</div>
                  <div style={styles.highlightText}>
                    <strong>Durée :</strong> 12 mois de collecte intensive
                  </div>
                </div>
              </div>
            </div>

            
            <div style={styles.timelineItem}>
              <div style={styles.timelineDot}></div>
              <div style={styles.timelineContent}>
                <div style={styles.timelineDate}>Février 2027</div>
                <h3 style={styles.timelineTitle}>Fin de la collecte</h3>
                <p style={styles.timelineText}>
                  Clôture des travaux de terrain et début du traitement des données
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Section final message */}
        <section style={styles.finalSection}>
          <div style={styles.finalCard}>
            <div style={styles.finalIcon}>🚀</div>
            <h5 style={styles.finalTitle}>Une étape cruciale pour le développement du Burundi</h5>
            <p style={styles.finalText}>
               La formation des agents enquêteurs marque le début d'un processus majeur de collecte de données qui éclairera 
                les politiques de développement du Burundi pour les années à venir. Les résultats de l'EICVMB 2025-2026 
                constitueront une référence essentielle pour mesurer les progrès vers la Vision Burundi 2040-2060 et les 
                objectifs de développement durable.
            </p>
            <div style={styles.finalBadge}>
              Collecte nationale en cours jusqu'à février 2027
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
    width: '100%',
  },
  header: {
    textAlign: 'center',
    marginBottom: '50px',
    paddingTop: '30px',
  },
  badge: {
    display: 'inline-block',
    backgroundColor: '#E30613',
    color: 'white',
    padding: '8px 20px',
    borderRadius: '20px',
    fontSize: '0.9rem',
    fontWeight: '600',
    marginBottom: '20px',
    letterSpacing: '1px',
  },
  mainTitle: {
    color: '#008D36',
    fontSize: '2.2rem',
    marginBottom: '15px',
    fontWeight: '700',
    lineHeight: 1.2,
  },
  subTitle: {
    color: '#333',
    fontSize: '1.3rem',
    marginBottom: '30px',
    fontWeight: '400',
    opacity: 0.8,
  },
  dateBox: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: 'white',
    padding: '15px 25px',
    borderRadius: '10px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
    marginTop: '10px',
  },
  dateIcon: {
    fontSize: '1.8rem',
    marginRight: '15px',
    color: '#008D36',
  },
  dateText: {
    textAlign: 'left',
  },
  dateLabel: {
    fontSize: '0.9rem',
    color: '#666',
    marginBottom: '5px',
  },
  dateValue: {
    fontSize: '1.2rem',
    fontWeight: '600',
    color: '#008D36',
  },
  introSection: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '12px',
    marginBottom: '50px',
    boxShadow: '0 5px 20px rgba(0,0,0,0.05)',
  },
  introContent: {
    flex: 1,
  },
  introTitle: {
    color: '#008D36',
    fontSize: '1.5rem',
    marginBottom: '15px',
    fontWeight: '600',
  },
  introText: {
    fontSize: '1.1rem',
    lineHeight: 1.7,
    color: '#444',
    maxWidth: '90%',
  },
  introIcon: {
    fontSize: '4rem',
    color: '#008D36',
    opacity: 0.2,
  },
  gallerySection: {
    marginBottom: '60px',
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '30px',
    paddingBottom: '15px',
    borderBottom: '2px solid #f0f0f0',
  },
  sectionNumber: {
    backgroundColor: '#E30613',
    color: 'white',
    padding: '8px 20px',
    borderRadius: '4px',
    marginRight: '20px',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    minWidth: '60px',
    textAlign: 'center',
  },
  sectionTitle: {
    color: '#008D36',
    fontSize: '1.8rem',
    fontWeight: '600',
  },
  photoGrid: {
    display: 'grid',
    gap: '30px',
    marginBottom: '40px',
  },
  largePhotoContainer: {
    position: 'relative',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
  },
  largePhoto: {
    width: '100%',
    height: '400px',
    objectFit: 'cover',
    transition: 'transform 0.3s ease',
  },
  photoOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
    color: 'white',
    padding: '30px',
  },
  photoTag: {
    display: 'inline-block',
    backgroundColor: '#008D36',
    color: 'white',
    padding: '5px 15px',
    borderRadius: '20px',
    fontSize: '0.9rem',
    fontWeight: '600',
    marginBottom: '10px',
  },
  photoDescription: {
    fontSize: '1.2rem',
    fontWeight: '500',
    margin: 0,
  },
  photoCard: {
    backgroundColor: 'white',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  },
  photo: {
    width: '100%',
    height: '200px',
    objectFit: 'cover',
  },
  photoInfo: {
    padding: '20px',
  },
  photoTitle: {
    color: '#008D36',
    fontSize: '1.2rem',
    marginBottom: '10px',
    fontWeight: '600',
  },
  photoCaption: {
    color: '#666',
    fontSize: '0.95rem',
    lineHeight: 1.5,
    margin: 0,
  },
  objectivesSection: {
    marginBottom: '60px',
  },
  objectivesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '25px',
  },
  objectiveCard: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '12px',
    textAlign: 'center',
    boxShadow: '0 5px 15px rgba(0,0,0,0.05)',
    transition: 'transform 0.3s ease',
    borderTop: '4px solid #008D36',
  },
  objectiveIcon: {
    fontSize: '2.5rem',
    marginBottom: '20px',
  },
  objectiveTitle: {
    color: '#008D36',
    fontSize: '1.3rem',
    marginBottom: '15px',
    fontWeight: '600',
  },
  objectiveText: {
    color: '#666',
    lineHeight: 1.6,
    fontSize: '0.95rem',
  },
  timelineSection: {
    marginBottom: '60px',
  },
  timeline: {
    position: 'relative',
    paddingLeft: '30px',
  },
  timelineItem: {
    position: 'relative',
    marginBottom: '40px',
    display: 'flex',
  },
  timelineDot: {
    position: 'absolute',
    left: '-38px',
    top: '0',
    width: '16px',
    height: '16px',
    backgroundColor: '#008D36',
    borderRadius: '50%',
    border: '4px solid white',
    boxShadow: '0 0 0 3px #008D36',
  },
  timelineContent: {
    backgroundColor: 'white',
    padding: '25px',
    borderRadius: '10px',
    boxShadow: '0 5px 15px rgba(0,0,0,0.05)',
    flex: 1,
  },
  timelineDate: {
    color: '#E30613',
    fontSize: '1rem',
    fontWeight: '600',
    marginBottom: '10px',
  },
  timelineTitle: {
    color: '#008D36',
    fontSize: '1.3rem',
    marginBottom: '15px',
    fontWeight: '600',
  },
  timelineText: {
    color: '#666',
    lineHeight: 1.6,
    marginBottom: '15px',
  },
  highlightBox: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f0f9f0',
    padding: '15px',
    borderRadius: '8px',
    marginTop: '15px',
  },
  highlightIcon: {
    fontSize: '1.5rem',
    marginRight: '15px',
    color: '#008D36',
  },
  highlightText: {
    color: '#333',
    fontSize: '1rem',
  },
  coverageSection: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '40px',
    marginBottom: '50px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
  },
  coverageContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '40px',
  },
  coverageText: {
    flex: 1,
  },
  coverageTitle: {
    color: '#008D36',
    fontSize: '1.8rem',
    marginBottom: '20px',
    fontWeight: '700',
  },
  coverageDescription: {
    fontSize: '1.1rem',
    lineHeight: 1.7,
    color: '#444',
    marginBottom: '30px',
  },
  coverageStats: {
    display: 'flex',
    gap: '30px',
  },
  statItem: {
    textAlign: 'center',
  },
  statNumber: {
    fontSize: '2.2rem',
    fontWeight: '700',
    color: '#E30613',
    marginBottom: '5px',
  },
  statLabel: {
    fontSize: '0.9rem',
    color: '#666',
    fontWeight: '600',
  },
  coverageImage: {
    flex: 1,
  },
  mapPlaceholder: {
    backgroundColor: '#f0f9f0',
    height: '250px',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px dashed #008D36',
  },
  mapIcon: {
    fontSize: '4rem',
    color: '#008D36',
    marginBottom: '15px',
    opacity: 0.5,
  },
  mapText: {
    color: '#008D36',
    fontSize: '1rem',
    fontWeight: '600',
  },
  finalSection: {
    marginBottom: '60px',
  },
  finalCard: {
    backgroundColor: '#008D36',
    color: 'white',
    padding: '50px',
    borderRadius: '12px',
    textAlign: 'center',
    boxShadow: '0 15px 40px rgba(0, 141, 54, 0.2)',
  },
  finalIcon: {
    fontSize: '4rem',
    marginBottom: '20px',
    opacity: 0.9,
  },
  finalTitle: {
    fontSize: '2rem',
    marginBottom: '20px',
    fontWeight: '700',
  },
  finalText: {
    fontSize: '1.2rem',
    lineHeight: 1.6,
    maxWidth: '800px',
    margin: '0 auto 30px',
    opacity: 0.9,
  },
  finalBadge: {
    display: 'inline-block',
    backgroundColor: 'rgba(255,255,255,0.2)',
    color: 'white',
    padding: '12px 25px',
    borderRadius: '30px',
    fontSize: '1.1rem',
    fontWeight: '600',
    border: '2px solid rgba(255,255,255,0.3)',
  },
};

export default FormationPage;